import styled from '@emotion/styled'
import { Box, CssBaseline, Paper } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'

import DaiLogo from '@/components/DaiLogo'
import GlobalStyle from '@/components/GlobalStyle'

interface AuthType {
  children?: React.ReactNode
}

const Root = styled.div`
  max-width: 520px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  flex-direction: column;
`

const Auth: React.FC<AuthType> = ({ children }) => {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <DaiLogo />
      <Box sx={{ px: 6, width: '100%' }}>
        <Paper sx={{ padding: 6, width: '100%' }}>
          {children}
          <Outlet />
        </Paper>
      </Box>
    </Root>
  )
}

export default Auth
